/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */


/**
 * field to filter for ticket search:
 *   * OPENED
 *   * TRANSFERED
 *   * IN_PROGRESS
 *   * ESTIMATED
 *   * START_ESTIMATED
 *   * CLOSED
 */
export enum TicketState {
  OPENED = 'OPENED',
  TRANSFERED = 'TRANSFERED',
  IN_PROGRESS = 'IN_PROGRESS',
  ESTIMATED = 'ESTIMATED',
  START_ESTIMATED = 'START_ESTIMATED',
  CLOSED = 'CLOSED'
}
